class CollectionTabs extends HTMLElement {
  connectedCallback() {
    this.tabButtons = Array.from(this.querySelectorAll('.collection-tabs__tab-btn'));
    this.panels = Array.from(this.querySelectorAll('.collection-tabs__panel'));

    this.tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => this.activateTab(btn));
    });

    this.querySelectorAll('[data-carousel-prev]').forEach((btn) => {
      btn.addEventListener('click', () => this.scrollCarousel(btn, -1));
    });

    this.querySelectorAll('[data-carousel-next]').forEach((btn) => {
      btn.addEventListener('click', () => this.scrollCarousel(btn, 1));
    });
  }

  scrollCarousel(btn, direction) {
    const track = btn.closest('.collection-tabs__carousel')?.querySelector('.collection-tabs__grid');
    if (!track) return;
    const card = track.querySelector('.collection-tabs__card');
    const cardWidth = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.6;
    track.scrollBy({ left: cardWidth * direction * 2, behavior: 'smooth' });
  }

  activateTab(btn) {
    const index = btn.getAttribute('data-tab-index');

    this.tabButtons.forEach((b) => {
      const isActive = b === btn;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.getAttribute('data-tab-panel-index') === index;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }
}

if (!customElements.get('collection-tabs')) {
  customElements.define('collection-tabs', CollectionTabs);
}
